import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} dailyBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  dailyBalance,
  selectedStore,
  selectedDate,
  totalCashPayed,
  totalCardPayed
) => {
  const dailyBalanceNotDeleted = dailyBalance.filter(
    (x) => x.deleted_at == null
  );
  let totalIncome = 0;
  const excelData = [];
  for (let item = 0; item < dailyBalanceNotDeleted.length; item++) {
    const balance = dailyBalanceNotDeleted[item];
    const itemConceptArray = [];
    const itemTotalPrice = balance.total_net;

    balance.Sell_details.forEach((element) => {
      if (element.Service) {
        itemConceptArray.push(element.quantity + " " + element.Service.name);
      } else if (element.Product) {
        itemConceptArray.push(element.quantity + " " + element.Product.name);
      } else if (element.Offer) {
        itemConceptArray.push(element.quantity + " " + element.Offer.name);
      }
    });
    const itemConcept = itemConceptArray.join("/");

    excelData.push({
      order: item + 1,
      receiptId: balance.receipt_id,
      store: balance.Store.name,
      createdAt: balance.created_at_hour,
      customer: `${balance.Customer.name} ${balance.Customer.lastname}`,
      itemConcept,
      paymentType: balance.Sell_payment_type.name,
      itemTotalPrice,
    });

    totalIncome += itemTotalPrice;
  }

  excelData.push({
    order: "",
    receiptId: "",
    store: "",
    createdAt: "",
    customer: "TOTAL",
    itemConcept: totalIncome,
    paymentType: "",
    itemTotalPrice: "",
  });
  excelData.push({
    order: "",
    receiptId: "",
    store: "EN EFECTIVO",
    createdAt: totalCashPayed,
    customer: "CON TARJETA",
    itemConcept: totalCardPayed,
    paymentType: "",
    itemTotalPrice: "",
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE DIARIO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "receiptId",
            outValue: "CODIGO DE VENTA",
          },
          {
            inValue: "store",
            outValue: "SEDE",
          },
          {
            inValue: "createdAt",
            outValue: "HORA",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "itemConcept",
            outValue: "CONCEPTO",
          },
          {
            inValue: "paymentType",
            outValue: "METODO DE PAGO",
          },
          {
            inValue: "itemTotalPrice",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, selectedDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, selectedDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(selectedDate) +
        "_reporte-general-balance-diario.xlsx"
    : formatHelper.toDateYYMMDD(selectedDate) +
        "_reporte-balance-diario_" +
        storeName.toLowerCase() +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/DailyBalance/excel.js